package dev.lingvo.site.pages.app.projects

import androidx.compose.runtime.Composable
import dev.lingvo.shared.Role
import dev.lingvo.site.api.ApiException
import dev.lingvo.site.ds.LAlert
import dev.lingvo.site.ds.LAlertVariant
import dev.lingvo.site.ds.LButtonVariant
import dev.lingvo.site.ds.LLinkButton
import dev.lingvo.site.i18n.t

internal fun isProjectLimitFailure(failure: Throwable): Boolean =
    failure is ApiException && failure.status == 403 && failure.code == "project_limit_reached"

@Composable
internal fun ProjectLimitNotice(role: Role?) {
    LAlert(
        title = t("app.projects.project_limit_notice.this_workspace_has_reached_its_project", "This workspace has reached its project limit"),
        description = if (role == Role.OWNER) {
            t("app.projects.project_limit_notice.your_existing_projects_remain_usable_you", "Your existing projects remain usable. You can add files to an existing project, " +
                "or review plans to add another project. Your entries below are still here.")
        } else {
            t("app.projects.project_limit_notice.your_existing_projects_remain_usable_you_2", "Your existing projects remain usable. You can add files to an existing project, " +
                "or ask a workspace owner to review plans. Your entries below are still here.")
        },
        variant = LAlertVariant.INFO,
        live = true,
        action = if (role == Role.OWNER) {
            {
                LLinkButton(
                    label = t("app.projects.project_limit_notice.review_plans", "Review plans"),
                    path = "/app/settings/billing/plans",
                    variant = LButtonVariant.SECONDARY,
                )
            }
        } else null,
    )
}
